var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"overflow":"hidden"}},[_c('iframe',{staticClass:"iframe",attrs:{"src":`https://metabase-new.sharechat.com/public/dashboard/2a6c97ff-417d-4c15-bb00-d7ceb51cc495?tsmnumber=${_vm.retailerId}&start_date=${_vm.date}&end_date=${_vm.date}`,"title":"My associates"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }